import { createApp } from 'vue'
import App from './App.vue'
import BootstrapVue3 from 'bootstrap-vue-3'
import router from './router'
import { createAuth0 } from '@auth0/auth0-vue'
import { getAppConfig } from './services/appConfig'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'

const { auth0Domain, auth0ClientId, auth0Audience } = getAppConfig()

console.log('[Auth0] Registering plugin —', { auth0Domain })

const app = createApp(App)
app.use(router)
app.use(BootstrapVue3)
app.use(
  createAuth0({
    domain: auth0Domain,
    clientId: auth0ClientId,
    // Persist tokens across tabs so opening a deep link in a new tab
    // (e.g. /post-mortem?ticker=MU from the portfolio icons) doesn't need
    // a silent-auth iframe round-trip and shows content immediately.
    cacheLocation: 'localstorage',
    useRefreshTokens: true,
    // When no usable refresh token is cached (never issued, expired, or rotated
    // away), fall back to the iframe-based /authorize silent-auth flow against
    // the still-valid Auth0 SSO session instead of throwing "Missing Refresh
    // Token". Defaults to false in auth0-spa-js v2.
    useRefreshTokensFallback: true,
    authorizationParams: {
      redirect_uri: window.location.origin,
      audience: auth0Audience,
      // offline_access is auto-added by the SDK when useRefreshTokens is on;
      // requesting it explicitly keeps refresh-token issuance unambiguous.
      scope: 'openid profile email offline_access',
    },
  })
)
app.mount('#app')
